import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { COMPANY, SERVICES, SERVICE_AREAS } from "../../data/site";
import { getPopularLandingPages } from "../../data/landing";
import hazLogo from "../../assets/haz-logo.png";

const POPULAR = getPopularLandingPages(14);

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-bone pt-20 pb-10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-14 border-b border-bone/15">
                    <div className="md:col-span-3">
                        <div className="flex items-center gap-3 mb-5">
                            <img
                                src={hazLogo}
                                alt="HAZ Insulation"
                                className="h-[5.12rem] w-auto"
                            />
                        </div>
                        <p className="text-bone/65 text-sm leading-relaxed max-w-xs">
                            Spray foam, cellulose, attic &amp; crawl space systems across Chicago
                            Southland and Northwest Indiana. NICOR &amp; ComEd rebate partner.
                        </p>
                        <div className="mt-6 space-y-2 text-sm">
                            <a
                                href={COMPANY.phoneHref}
                                className="flex items-center gap-2 hover:text-ember"
                                data-testid="footer-phone-link"
                            >
                                <Phone size={14} strokeWidth={1.5} /> {COMPANY.phone}
                            </a>
                            <a
                                href={COMPANY.emailHref}
                                className="flex items-center gap-2 hover:text-ember"
                                data-testid="footer-email-link"
                            >
                                <Mail size={14} strokeWidth={1.5} /> {COMPANY.email}
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-ember font-bold mb-5">
                            Services
                        </div>
                        <ul className="space-y-2.5 text-sm text-bone/75">
                            {SERVICES.slice(0, 8).map((s) => (
                                <li key={s.id}>
                                    <Link
                                        to={`/services/${s.id}`}
                                        className="link-underline hover:text-ember"
                                    >
                                        {s.title}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/services"
                                    className="link-underline hover:text-ember font-semibold"
                                >
                                    All services →
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-ember font-bold mb-5">
                            Popular Searches
                        </div>
                        <ul className="space-y-2 text-sm text-bone/75">
                            {POPULAR.map((p) => (
                                <li key={p.slug}>
                                    <Link
                                        to={`/${p.slug}`}
                                        data-testid={`footer-popular-${p.slug}`}
                                        className="link-underline hover:text-ember"
                                    >
                                        {p.product.shortLabel} · {p.area.city}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-ember font-bold mb-5">
                            Service Areas
                        </div>
                        <ul className="space-y-2 text-sm text-bone/75 columns-1">
                            {SERVICE_AREAS.map((a) => (
                                <li key={a.slug}>
                                    <Link
                                        to={`/areas/${a.slug}`}
                                        className="link-underline hover:text-ember"
                                    >
                                        {a.city}, {a.state}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <Link
                            to="/service-areas"
                            className="link-underline hover:text-ember font-semibold text-sm mt-3 inline-block"
                        >
                            All service areas →
                        </Link>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-6 gap-6 py-8 border-b border-bone/15 text-sm">
                    <Link to="/about" className="link-underline hover:text-ember text-bone/75">About</Link>
                    <Link to="/reviews" className="link-underline hover:text-ember text-bone/75">Reviews</Link>
                    <Link to="/contractors" className="link-underline hover:text-ember text-bone/75">Contractors</Link>
                    <Link to="/contact" className="link-underline hover:text-ember text-bone/75">Free Quote</Link>
                    <Link to="/services" className="link-underline hover:text-ember text-bone/75">Services</Link>
                    <Link to="/sitemap" className="link-underline hover:text-ember text-bone/75" data-testid="footer-sitemap-link">Sitemap</Link>
                </div>

                <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-bone/55">
                    <div>
                        © {year} {COMPANY.legal}. All rights reserved.
                    </div>
                    <div>
                        Licensed &amp; insured · IL &amp; IN · NICOR Rebate Partner
                    </div>
                </div>
            </div>
        </footer>
    );
};
